import { Component } from "react";
import { ImageWithText } from "../components/visual/ImageWithText";
import { primary } from "src/styles/Colors";
import { SectionHeader } from "src/components/visual/SectionHeader";
import * as React from "react";
import bg from "../images/dark_wall.png";
import msl1 from "../images/products/msl1.jpg";
import msl3 from "../images/products/msl3.jpg";
import shells1 from "../images/shells1_bw.jpg"
import article1 from "../images/articles/article1.jpeg";
import article2 from "../images/articles/article2.jpeg";
import article3 from "../images/articles/article3.jpeg";
import article4 from "../images/articles/article4.jpeg";
import article1sqr from "../images/articles/article1sqr.jpeg";
import article2sqr from "../images/articles/article2sqr.jpeg";
import article3sqr from "../images/articles/article3sqr.jpeg";
import article4sqr from "../images/articles/article4sqr.jpeg";
import ModalImage from "react-modal-image";

export class InActionView extends Component {
    public render() {
        return (
            <div>
                <section style={{ paddingTop: "5rem", paddingBottom: "5rem", backgroundSize: "cover", backgroundPosition: "center", backgroundImage: `url(${shells1})` }}>
                    <SectionHeader title="In Action" subtitle="Erfahren Sie mehr über unsere Produkte" titleColor={primary} subtitleColor="white"/>
                </section>
                <div style={{ backgroundColor: "#121215", paddingTop: "3rem", paddingBottom: "3rem" }}>
                    <div className="grid-container text-center" style={{ marginBottom: "2rem" }}>
                        <h2>Was ist MSL?</h2>
                        <hr className="color-neutral" style={{ borderWidth: ".125rem" }}/>
                        <div className="grid-x align-middle">
                            <div className="cell medium-4">
                                <p className="white">
                                    Der MSL (Magnet-Schnelllader) ist ein magnetischer Schnelllader, der schnelles Laden doppelläufiger Flinten ermöglicht.
                                </p>
                            </div>
                            <div className="cell medium-4">
                                <p className="white">
                                    Geeignet für einen Rohrabstand zwischen 25 und 30 mm.
                                </p>
                            </div>
                            <div className="cell medium-4">
                                <p className="white">
                                    Gefräst aus einem hochwertigen Stück Polyamid, kein Spritzgruß.<br/>
                                    Made in Germany!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ backgroundImage: `url(${bg})`, paddingTop: "3rem", paddingBottom: "3rem" }}>
                    <div className="grid-container text-center" style={{ marginBottom: "2rem" }}>
                        <h2>Einsatzmöglichkeiten</h2>
                        <hr className="color-neutral" style={{ borderWidth: ".125rem" }}/>
                        <p className="white">
                            Unsere Produkte sind in unterschiedlichen Gebieten anwendbar.<br/>
                            Hier stellen wir Ihnen einige Anwendungsbeispiele vor.
                        </p>
                    </div>
                    <ImageWithText imagePosition="right" imgSrc={msl1} header="Für Jäger" text={["Einfache Handhabung", "Für Bock- und Doppelflinten", "Passend für Kaliber 12-16-20 .410"]} style={{ marginBottom: "2rem" }}/>
                    <ImageWithText imagePosition="left" imgSrc={msl3} header="Für Sportschützen" text={["Deutlich kürzere Ladezeiten", "Sportlich zugelassen z. B. in BDS Disziplin SP Speed Steel", "Passend zu gängigen Nylon-Schlaufen-Schrotpatronengürtel oder direkt in Patronen-Clips"]} style={{ marginBottom: "1rem" }}/>
                    {/* <div className="grid-container">
                        <div className="grid-x">
                            <div className="cell cell-small-12">
                                <iframe src="https://www.youtube-nocookie.com/embed/WOoUVeyaY_8?start=177" width="100%" height="720px" frameBorder={0} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} />
                            </div>
                        </div>
                    </div> */}
                </div>
                <div style={{ backgroundColor: "#121215", paddingTop: "3rem", paddingBottom: "3rem" }}>
                    <div className="grid-container text-center" style={{ marginBottom: "2rem" }}>
                        <h3>Markt-Info in der Deutschen Jagd Zeitung Ausgabe 01/2019</h3>
                        <hr className="color-neutral" style={{ borderWidth: ".125rem" }}/>
                        <div className="grid-x align-middle" style={{ marginTop: "1rem" }}>
                            <div className="cell medium-4 medium-offset-1" >
                                <ModalImage
                                    small={article2sqr}
                                    large={article2}
                                    hideDownload={true}
                                    hideZoom={true}
                                />
                            </div>
                            <div className="cell medium-4 medium-offset-2">
                                <ModalImage
                                    small={article3sqr}
                                    large={article3}
                                    hideDownload={true}
                                    hideZoom={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ backgroundColor: "#121215", paddingTop: "3rem", paddingBottom: "3rem" }}>
                    <div className="grid-container text-center" style={{ marginBottom: "2rem" }}>
                        <h3>Bericht in der Caliber 02/2019 (Seite 91 - Rubrik "Magazin")</h3>
                        <hr className="color-neutral" style={{ borderWidth: ".125rem" }}/>
                        <div className="grid-x align-middle" style={{ marginTop: "1rem" }}>
                            <div className="cell medium-4 medium-offset-1" >
                                <ModalImage
                                    small={article1sqr}
                                    large={article1}
                                    hideDownload={true}
                                    hideZoom={true}
                                />
                            </div>
                            <div className="cell medium-4 medium-offset-2">
                                <ModalImage
                                    small={article4sqr}
                                    large={article4}
                                    hideDownload={true}
                                    hideZoom={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/InActionView.tsx